
import { computed, defineComponent } from "@vue/runtime-core";
import SvgIcon from "@jamescoyle/vue-icon";

export default defineComponent({
  components: {
    SvgIcon,
  },
  inheritAttrs: true,
  props: {
    color: {
      type: String,
      default: () => "blue",
      validator: (value: string) => {
        // The value must match one of these strings
        return (
          [
            "primary",
            "secondary",
            "accent",
            "gray",
            "black",
            "blue",
            "green",
            "red",
            "white",
            "yellow",
          ].indexOf(value) !== -1
        );
      },
    },
    path: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: () => 24,
    },
  },
  setup(props) {
    const classNames = computed(() => {
      return `button button--text-${props.color}`;
    });

    return {
      classNames,
    };
  },
});
